"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _modal = require("../common/modal");

var _GetACardModal = _interopRequireDefault(require("./GetACardModal.html"));

var _NeedMoblieNumberPopover = _interopRequireDefault(require("../../components/need_mobile_number_popover/NeedMoblieNumberPopover"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var GetACardModal =
/*#__PURE__*/
function (_Modal) {
  _inherits(GetACardModal, _Modal);

  function GetACardModal() {
    var _this;

    _classCallCheck(this, GetACardModal);

    var classes = ['GetACardModal'];

    if (window.featureManager.isEnabled('OzoneAuthentication')) {
      classes.push('extraPadding');
    }

    var content = (0, _GetACardModal["default"])();
    var modalContents = {
      classes: classes,
      title: window.html('getCard.needCard'),
      hiddenTitle: true,
      content: content
    };
    Cookies.set('gacPromoDismissed', 1, {
      httpOnly: false
    });
    _this = _possibleConstructorReturn(this, _getPrototypeOf(GetACardModal).call(this, modalContents));

    if (window.featureManager.isEnabled('OzoneAuthentication')) {
      _this.numVerificationToolTip = new _NeedMoblieNumberPopover["default"](_this.$el.find('#needMyMobileNum')).render();
    }

    return _this;
  }

  return GetACardModal;
}(_modal.Modal);

exports["default"] = GetACardModal;